import {
  Icon,
  Icons,
  TypographyElement
} from 'UI'
import { createUseStyles, useTheme } from 'react-jss'
import styles from './style'
import Text from './text.json'

const useStyles = createUseStyles(styles)

const searchItemIcons = {
  Tags: 'search',
  Courses: 'video',
  Authors: 'user',
  learningPaths: 'path',
  history: 'clock'
}

export default ({ searchItem, icon, content = '', type, onClick, textClass, notFound, isFree, dataTest }) => {
  const { freeTag } = useStyles()
  const theme = useTheme()
  return (
    notFound
      ? (
        <div
          data-test='search-item-not-found'
          className={searchItem}
        >
          <TypographyElement
            variant='body1'
            Component='span'
            fontWeight={500}
            display='-webkit-box'
            className={textClass}
          >
            {content}
          </TypographyElement>
        </div>
        )
      : (
        <div className={searchItem} onClick={onClick}>
          {
            isFree
              ? (
                <TypographyElement
                  className={freeTag}
                  Component='span'
                  variant='caption'
                  display='inline-block'
                  fontSize='8px'
                  lineHeight='10px'
                  color={theme.success[0]}
                >{Text.free}
                </TypographyElement>
                )
              : <Icon iconName={Icons[searchItemIcons[type]]} style={icon} />
          }
          <TypographyElement
            dataTest={dataTest}
            variant='body1'
            Component='span'
            display='-webkit-box'
            className={textClass}
            dangerouslySetText={content}
          />
        </div>
        )
  )
}
